export const normalizeWorkScheduleRecipients = (data) => (
  (Array.isArray(data) ? data : data?.recipients || []).map((recipient) => ({
    ...recipient,
    recipient_id: Number(recipient.recipient_id || recipient.id),
    name: recipient.recipient_name
      || recipient.name
      || [recipient.first_name, recipient.last_name].filter(Boolean).join(" ")
      || recipient.email
      || `Team member ${recipient.recipient_id || recipient.id}`,
  }))
);

export default normalizeWorkScheduleRecipients;
